import axios from 'axios'

export const state = {
  settings: {},
}

export const getters = {
  get: state => path => {
    return state.settings[path]
  },
}

export const mutations = {
  SET_ALL(state, payload) {
    if (payload) {
      let result = {}
      for (const settings of payload) {
        result[settings.name] = settings.value
      }
      state.settings = result
    }
  },
}

export const actions = {
  load({commit, dispatch}) {
    axios.get(`/api/1/globalsettings`, {}).then(response => {
      if(response.data)
        commit('SET_ALL', response.data.content)
    })
  }
}




